/* eslint-disable */
/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  T | { [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never };
import type { TypedDocumentNode as DocumentNode } from "@graphql-typed-document-node/core";
export type EcAnalysesQueryVariables = Exact<{ [key: string]: never }>;

export type EcAnalysesQuery = {
  analyses: Array<{
    access_and_affordability_alert: boolean | null;
    analysis_tooltip: string | null;
    annual_dosage_assumptions: string | null;
    appraisal_committee: string | null;
    asset_group_id: string | null;
    date_of_review: string | null;
    details_enabled: boolean | null;
    differentiator: string | null;
    drug_tags: string | null;
    ebm_rating: string | null;
    general_condition: string | null;
    generic_name: string | null;
    health_system_cost_ratio_evlyg: unknown;
    health_system_cost_ratio_qaly: unknown;
    health_system_vbpb_100k_per_evlyg: unknown;
    health_system_vbpb_100k_per_qaly: unknown;
    health_system_vbpb_150k_per_evlyg: unknown;
    health_system_vbpb_150k_per_qaly: unknown;
    health_system_vbpb_200k_per_evlyg: unknown;
    health_system_vbpb_200k_per_qaly: unknown;
    health_system_vbpb_50k_per_evlyg: unknown;
    health_system_vbpb_50k_per_qaly: unknown;
    id: string;
    is_outdated_analysis: boolean | null;
    manufacturer: string | null;
    manufacturer_health_system_vbpb_100k_per_evlyg: unknown;
    manufacturer_health_system_vbpb_100k_per_qaly: unknown;
    manufacturer_health_system_vbpb_150k_per_evlyg: unknown;
    manufacturer_health_system_vbpb_150k_per_qaly: unknown;
    manufacturer_health_system_vbpb_200k_per_evlyg: unknown;
    manufacturer_health_system_vbpb_200k_per_qaly: unknown;
    manufacturer_health_system_vbpb_50k_per_evlyg: unknown;
    manufacturer_health_system_vbpb_50k_per_qaly: unknown;
    manufacturer_societal_vbpb_100k_per_evlyg: unknown;
    manufacturer_societal_vbpb_100k_per_qaly: unknown;
    manufacturer_societal_vbpb_150k_per_evlyg: unknown;
    manufacturer_societal_vbpb_150k_per_qaly: unknown;
    manufacturer_societal_vbpb_200k_per_evlyg: unknown;
    manufacturer_societal_vbpb_200k_per_qaly: unknown;
    manufacturer_societal_vbpb_50k_per_evlyg: unknown;
    manufacturer_societal_vbpb_50k_per_qaly: unknown;
    method_of_administration: string | null;
    net_price: unknown;
    orphan_statuses: Array<string> | null;
    population_and_comparator: string | null;
    societal_cost_ratio_evlyg: unknown;
    societal_cost_ratio_qaly: unknown;
    societal_vbpb_100k_per_evlyg: unknown;
    societal_vbpb_100k_per_qaly: unknown;
    societal_vbpb_150k_per_evlyg: unknown;
    societal_vbpb_150k_per_qaly: unknown;
    societal_vbpb_200k_per_evlyg: unknown;
    societal_vbpb_200k_per_qaly: unknown;
    societal_vbpb_50k_per_evlyg: unknown;
    societal_vbpb_50k_per_qaly: unknown;
    specific_condition: string | null;
    specific_condition_tags: string | null;
    trade_name: string | null;
    type_of_review: string | null;
    unpublished: boolean | null;
    wac: unknown;
    alternative_im_output_attributes: {
      key: string;
      url: string;
      filename: string;
      content_type: string | null;
      byte_size: number;
      checksum: string;
    } | null;
  }>;
};

export type EcAssetGroupsQueryVariables = Exact<{ [key: string]: never }>;

export type EcAssetGroupsQuery = {
  asset_groups: Array<{
    id: string;
    date_of_review: string | null;
    unpublished: boolean | null;
    status: string | null;
    recommendation_callout: string | null;
    created_at: unknown;
    specific_conditions: Array<string | null>;
    drugs: Array<string>;
    documents: Array<{
      key: string;
      url: string;
      filename: string;
      content_type: string | null;
      byte_size: number;
      checksum: string;
    } | null>;
    videos: Array<{ field_name: string; id: string; title: string }>;
    media_resource: {
      id: string;
      resource_type: string | null;
      youtube_id: string | null;
      title: string | null;
      description: string | null;
      sort_order: number | null;
      created_at: unknown;
      unpublished: boolean;
      status: string;
      display_date: string | null;
      platform_tags: any;
      registration_url: string | null;
      attachments: Array<{
        key: string;
        url: string;
        filename: string;
        content_type: string | null;
        byte_size: number;
        checksum: string;
      }>;
    } | null;
  }>;
};

export type EcComingSoonQueryVariables = Exact<{ [key: string]: never }>;

export type EcComingSoonQuery = {
  coming_soon_media_resources: Array<{
    id: string;
    resource_type: string | null;
    youtube_id: string | null;
    title: string | null;
    description: string | null;
    sort_order: number | null;
    created_at: unknown;
    unpublished: boolean;
    status: string;
    display_date: string | null;
    platform_tags: any;
    registration_url: string | null;
    attachments: Array<{
      key: string;
      url: string;
      filename: string;
      content_type: string | null;
      byte_size: number;
      checksum: string;
    }>;
    asset_group: {
      id: string;
      date_of_review: string | null;
      unpublished: boolean | null;
      status: string | null;
      recommendation_callout: string | null;
      created_at: unknown;
      specific_conditions: Array<string | null>;
      drugs: Array<string>;
      documents: Array<{
        key: string;
        url: string;
        filename: string;
        content_type: string | null;
        byte_size: number;
        checksum: string;
      } | null>;
      videos: Array<{ field_name: string; id: string; title: string }>;
    } | null;
  }>;
};

export type EcMediaResourcesQueryVariables = Exact<{ [key: string]: never }>;

export type EcMediaResourcesQuery = {
  media_resources: Array<{
    id: string;
    resource_type: string | null;
    youtube_id: string | null;
    title: string | null;
    description: string | null;
    sort_order: number | null;
    created_at: unknown;
    unpublished: boolean;
    status: string;
    display_date: string | null;
    platform_tags: any;
    registration_url: string | null;
    attachments: Array<{
      key: string;
      url: string;
      filename: string;
      content_type: string | null;
      byte_size: number;
      checksum: string;
    }>;
  }>;
};

export type EcRecentUpdatesQueryVariables = Exact<{ [key: string]: never }>;

export type EcRecentUpdatesQuery = {
  recent_updates: Array<{
    id: string;
    display_date: string | null;
    created_at: unknown;
    unpublished: boolean;
    body_html: string | null;
    attachments: Array<{
      key: string;
      url: string;
      filename: string;
      content_type: string | null;
      byte_size: number;
      checksum: string;
    }>;
  }>;
};

export type EcUserAnalysesQueryVariables = Exact<{ [key: string]: never }>;

export type EcUserAnalysesQuery = {
  user_analyses: Array<{
    id: string;
    analysis_id: string;
    add_to_compare: boolean | null;
    user_proposed_price: unknown;
  }>;
};

export type EcSetUserAnalysisMutationVariables = Exact<{
  analysis_id: string | number;
  add_to_compare?: boolean | null | undefined;
  user_proposed_price?: unknown;
}>;

export type EcSetUserAnalysisMutation = {
  set_user_analysis: {
    user_analysis: {
      id: string;
      analysis_id: string;
      add_to_compare: boolean | null;
      user_proposed_price: unknown;
    } | null;
    errors: Array<{ attribute: string | null; message: string }>;
  } | null;
};

export type EcViewerQueryVariables = Exact<{ [key: string]: never }>;

export type EcViewerQuery = {
  viewer: {
    id: string;
    email: string;
    first_name: string | null;
    last_name: string | null;
    phone_number: string | null;
    ec_access: boolean;
    im_access: boolean;
    organization: {
      id: number;
      name: string | null;
      ec_subscription: string;
      users_can_save_price: boolean;
    } | null;
  } | null;
};

export const EcAnalysesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "EcAnalyses" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "analyses" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "access_and_affordability_alert" } },
                { kind: "Field", name: { kind: "Name", value: "analysis_tooltip" } },
                { kind: "Field", name: { kind: "Name", value: "annual_dosage_assumptions" } },
                { kind: "Field", name: { kind: "Name", value: "appraisal_committee" } },
                { kind: "Field", name: { kind: "Name", value: "asset_group_id" } },
                { kind: "Field", name: { kind: "Name", value: "date_of_review" } },
                { kind: "Field", name: { kind: "Name", value: "details_enabled" } },
                { kind: "Field", name: { kind: "Name", value: "differentiator" } },
                { kind: "Field", name: { kind: "Name", value: "drug_tags" } },
                { kind: "Field", name: { kind: "Name", value: "ebm_rating" } },
                { kind: "Field", name: { kind: "Name", value: "general_condition" } },
                { kind: "Field", name: { kind: "Name", value: "generic_name" } },
                { kind: "Field", name: { kind: "Name", value: "health_system_cost_ratio_evlyg" } },
                { kind: "Field", name: { kind: "Name", value: "health_system_cost_ratio_qaly" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "health_system_vbpb_100k_per_evlyg" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "health_system_vbpb_100k_per_qaly" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "health_system_vbpb_150k_per_evlyg" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "health_system_vbpb_150k_per_qaly" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "health_system_vbpb_200k_per_evlyg" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "health_system_vbpb_200k_per_qaly" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "health_system_vbpb_50k_per_evlyg" },
                },
                { kind: "Field", name: { kind: "Name", value: "health_system_vbpb_50k_per_qaly" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "is_outdated_analysis" } },
                { kind: "Field", name: { kind: "Name", value: "manufacturer" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "manufacturer_health_system_vbpb_100k_per_evlyg" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "manufacturer_health_system_vbpb_100k_per_qaly" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "manufacturer_health_system_vbpb_150k_per_evlyg" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "manufacturer_health_system_vbpb_150k_per_qaly" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "manufacturer_health_system_vbpb_200k_per_evlyg" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "manufacturer_health_system_vbpb_200k_per_qaly" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "manufacturer_health_system_vbpb_50k_per_evlyg" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "manufacturer_health_system_vbpb_50k_per_qaly" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "manufacturer_societal_vbpb_100k_per_evlyg" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "manufacturer_societal_vbpb_100k_per_qaly" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "manufacturer_societal_vbpb_150k_per_evlyg" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "manufacturer_societal_vbpb_150k_per_qaly" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "manufacturer_societal_vbpb_200k_per_evlyg" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "manufacturer_societal_vbpb_200k_per_qaly" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "manufacturer_societal_vbpb_50k_per_evlyg" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "manufacturer_societal_vbpb_50k_per_qaly" },
                },
                { kind: "Field", name: { kind: "Name", value: "method_of_administration" } },
                { kind: "Field", name: { kind: "Name", value: "net_price" } },
                { kind: "Field", name: { kind: "Name", value: "orphan_statuses" } },
                { kind: "Field", name: { kind: "Name", value: "population_and_comparator" } },
                { kind: "Field", name: { kind: "Name", value: "societal_cost_ratio_evlyg" } },
                { kind: "Field", name: { kind: "Name", value: "societal_cost_ratio_qaly" } },
                { kind: "Field", name: { kind: "Name", value: "societal_vbpb_100k_per_evlyg" } },
                { kind: "Field", name: { kind: "Name", value: "societal_vbpb_100k_per_qaly" } },
                { kind: "Field", name: { kind: "Name", value: "societal_vbpb_150k_per_evlyg" } },
                { kind: "Field", name: { kind: "Name", value: "societal_vbpb_150k_per_qaly" } },
                { kind: "Field", name: { kind: "Name", value: "societal_vbpb_200k_per_evlyg" } },
                { kind: "Field", name: { kind: "Name", value: "societal_vbpb_200k_per_qaly" } },
                { kind: "Field", name: { kind: "Name", value: "societal_vbpb_50k_per_evlyg" } },
                { kind: "Field", name: { kind: "Name", value: "societal_vbpb_50k_per_qaly" } },
                { kind: "Field", name: { kind: "Name", value: "specific_condition" } },
                { kind: "Field", name: { kind: "Name", value: "specific_condition_tags" } },
                { kind: "Field", name: { kind: "Name", value: "trade_name" } },
                { kind: "Field", name: { kind: "Name", value: "type_of_review" } },
                { kind: "Field", name: { kind: "Name", value: "unpublished" } },
                { kind: "Field", name: { kind: "Name", value: "wac" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "alternative_im_output_attributes" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "key" } },
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                      { kind: "Field", name: { kind: "Name", value: "filename" } },
                      { kind: "Field", name: { kind: "Name", value: "content_type" } },
                      { kind: "Field", name: { kind: "Name", value: "byte_size" } },
                      { kind: "Field", name: { kind: "Name", value: "checksum" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<EcAnalysesQuery, EcAnalysesQueryVariables>;
export const EcAssetGroupsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "EcAssetGroups" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "asset_groups" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "date_of_review" } },
                { kind: "Field", name: { kind: "Name", value: "unpublished" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "recommendation_callout" } },
                { kind: "Field", name: { kind: "Name", value: "created_at" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "documents" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "key" } },
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                      { kind: "Field", name: { kind: "Name", value: "filename" } },
                      { kind: "Field", name: { kind: "Name", value: "content_type" } },
                      { kind: "Field", name: { kind: "Name", value: "byte_size" } },
                      { kind: "Field", name: { kind: "Name", value: "checksum" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "videos" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "field_name" } },
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "specific_conditions" } },
                { kind: "Field", name: { kind: "Name", value: "drugs" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "media_resource" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "resource_type" } },
                      { kind: "Field", name: { kind: "Name", value: "youtube_id" } },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                      { kind: "Field", name: { kind: "Name", value: "description" } },
                      { kind: "Field", name: { kind: "Name", value: "sort_order" } },
                      { kind: "Field", name: { kind: "Name", value: "created_at" } },
                      { kind: "Field", name: { kind: "Name", value: "unpublished" } },
                      { kind: "Field", name: { kind: "Name", value: "status" } },
                      { kind: "Field", name: { kind: "Name", value: "display_date" } },
                      { kind: "Field", name: { kind: "Name", value: "platform_tags" } },
                      { kind: "Field", name: { kind: "Name", value: "registration_url" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "attachments" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "key" } },
                            { kind: "Field", name: { kind: "Name", value: "url" } },
                            { kind: "Field", name: { kind: "Name", value: "filename" } },
                            { kind: "Field", name: { kind: "Name", value: "content_type" } },
                            { kind: "Field", name: { kind: "Name", value: "byte_size" } },
                            { kind: "Field", name: { kind: "Name", value: "checksum" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<EcAssetGroupsQuery, EcAssetGroupsQueryVariables>;
export const EcComingSoonDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "EcComingSoon" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "coming_soon_media_resources" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "resource_type" } },
                { kind: "Field", name: { kind: "Name", value: "youtube_id" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                { kind: "Field", name: { kind: "Name", value: "sort_order" } },
                { kind: "Field", name: { kind: "Name", value: "created_at" } },
                { kind: "Field", name: { kind: "Name", value: "unpublished" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "display_date" } },
                { kind: "Field", name: { kind: "Name", value: "platform_tags" } },
                { kind: "Field", name: { kind: "Name", value: "registration_url" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "attachments" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "key" } },
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                      { kind: "Field", name: { kind: "Name", value: "filename" } },
                      { kind: "Field", name: { kind: "Name", value: "content_type" } },
                      { kind: "Field", name: { kind: "Name", value: "byte_size" } },
                      { kind: "Field", name: { kind: "Name", value: "checksum" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "asset_group" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "date_of_review" } },
                      { kind: "Field", name: { kind: "Name", value: "unpublished" } },
                      { kind: "Field", name: { kind: "Name", value: "status" } },
                      { kind: "Field", name: { kind: "Name", value: "recommendation_callout" } },
                      { kind: "Field", name: { kind: "Name", value: "created_at" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "documents" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "key" } },
                            { kind: "Field", name: { kind: "Name", value: "url" } },
                            { kind: "Field", name: { kind: "Name", value: "filename" } },
                            { kind: "Field", name: { kind: "Name", value: "content_type" } },
                            { kind: "Field", name: { kind: "Name", value: "byte_size" } },
                            { kind: "Field", name: { kind: "Name", value: "checksum" } },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "videos" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "field_name" } },
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "title" } },
                          ],
                        },
                      },
                      { kind: "Field", name: { kind: "Name", value: "specific_conditions" } },
                      { kind: "Field", name: { kind: "Name", value: "drugs" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<EcComingSoonQuery, EcComingSoonQueryVariables>;
export const EcMediaResourcesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "EcMediaResources" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "media_resources" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "resource_type" } },
                { kind: "Field", name: { kind: "Name", value: "youtube_id" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                { kind: "Field", name: { kind: "Name", value: "sort_order" } },
                { kind: "Field", name: { kind: "Name", value: "created_at" } },
                { kind: "Field", name: { kind: "Name", value: "unpublished" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "display_date" } },
                { kind: "Field", name: { kind: "Name", value: "platform_tags" } },
                { kind: "Field", name: { kind: "Name", value: "registration_url" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "attachments" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "key" } },
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                      { kind: "Field", name: { kind: "Name", value: "filename" } },
                      { kind: "Field", name: { kind: "Name", value: "content_type" } },
                      { kind: "Field", name: { kind: "Name", value: "byte_size" } },
                      { kind: "Field", name: { kind: "Name", value: "checksum" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<EcMediaResourcesQuery, EcMediaResourcesQueryVariables>;
export const EcRecentUpdatesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "EcRecentUpdates" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "recent_updates" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "display_date" } },
                { kind: "Field", name: { kind: "Name", value: "created_at" } },
                { kind: "Field", name: { kind: "Name", value: "unpublished" } },
                { kind: "Field", name: { kind: "Name", value: "body_html" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "attachments" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "key" } },
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                      { kind: "Field", name: { kind: "Name", value: "filename" } },
                      { kind: "Field", name: { kind: "Name", value: "content_type" } },
                      { kind: "Field", name: { kind: "Name", value: "byte_size" } },
                      { kind: "Field", name: { kind: "Name", value: "checksum" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<EcRecentUpdatesQuery, EcRecentUpdatesQueryVariables>;
export const EcUserAnalysesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "EcUserAnalyses" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "user_analyses" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "analysis_id" } },
                { kind: "Field", name: { kind: "Name", value: "add_to_compare" } },
                { kind: "Field", name: { kind: "Name", value: "user_proposed_price" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<EcUserAnalysesQuery, EcUserAnalysesQueryVariables>;
export const EcSetUserAnalysisDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "EcSetUserAnalysis" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "analysis_id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "add_to_compare" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "user_proposed_price" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "ECMoney" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "set_user_analysis" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "analysis_id" },
                value: { kind: "Variable", name: { kind: "Name", value: "analysis_id" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "add_to_compare" },
                value: { kind: "Variable", name: { kind: "Name", value: "add_to_compare" } },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "user_proposed_price" },
                value: { kind: "Variable", name: { kind: "Name", value: "user_proposed_price" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user_analysis" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "analysis_id" } },
                      { kind: "Field", name: { kind: "Name", value: "add_to_compare" } },
                      { kind: "Field", name: { kind: "Name", value: "user_proposed_price" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "errors" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "attribute" } },
                      { kind: "Field", name: { kind: "Name", value: "message" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<EcSetUserAnalysisMutation, EcSetUserAnalysisMutationVariables>;
export const EcViewerDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "EcViewer" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "viewer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "email" } },
                { kind: "Field", name: { kind: "Name", value: "first_name" } },
                { kind: "Field", name: { kind: "Name", value: "last_name" } },
                { kind: "Field", name: { kind: "Name", value: "phone_number" } },
                { kind: "Field", name: { kind: "Name", value: "ec_access" } },
                { kind: "Field", name: { kind: "Name", value: "im_access" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "organization" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "ec_subscription" } },
                      { kind: "Field", name: { kind: "Name", value: "users_can_save_price" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<EcViewerQuery, EcViewerQueryVariables>;
